import styled from 'styled-components'
import Flickity from 'react-flickity-component'
import { irem } from '../../utils'
import { AltBg } from '../flexibleContent/fragments/altBg'

export const StyledFlickityImageComponent = styled(Flickity)<{$height?: number}>`
  width: 100%;
  margin: 0 auto;
  outline: 0;
  position: relative;

  .flickity-button {
    display: none;
  }

  .flickity-button:disabled {
    opacity: 0.3;
    cursor: auto;
    pointer-events: none;
  }

  ${props => props.theme.breakpoints.up('md')} {
    width: ${props => props.theme.typography.pxToRem(700)};
  }

  .flickity-viewport {
    overflow-x: hidden;
    overflow-y: hidden;

    ${props => props.theme.breakpoints.up('md')} {
      height: ${props => props.$height ? props.theme.typography.pxToRem(props.$height) : 'auto'} !important;
    }

    &:focus {
      outline: 0 !important;
    }
  }
`

export const StyledFlickityContentComponent = styled(Flickity)<{$height?: number}>`
  outline: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  ${props => props.theme.breakpoints.up('md')} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: calc(100% - ${irem(700)});
  }

  .flickity-button {
      display: none;
      
      ${props => props.theme.breakpoints.up('md')} {
          position: absolute;
          bottom: ${irem(20)};
          right: ${irem(20)};
          width: ${irem(72)};
          height: ${irem(48)};
          border-radius: ${irem(5)};
          color: black;
          border: 1px solid currentColor;
          fill: currentColor;
          display: block;
          background: none;
          cursor: pointer;
          transition: fill 0.1s ease-in-out, border 0.1s ease-in-out, color 0.1s ease-in-out;
          
          svg {
              position: relative;
              top: 1px;
              width: ${irem(16)};
              height: auto;
          }
          
          &.previous {
              right: ${irem(99)};
          }
          
          &:hover, &:focus {
              color: ${props => props.theme.custom.colors.darkRed};
          }
      }
  }

  .flickity-viewport {
    overflow-x: hidden;
    overflow-y: hidden;
    width: 100%;
      
    ${props => props.theme.breakpoints.up('md')} {
      max-height: ${irem(535)};
    }
      
    ${AltBg} & {
      background: white;
      border-radius: 0 0 ${irem(12)} ${irem(12)};

      ${props => props.theme.breakpoints.up('md')} {
        border-radius: 0 0 ${irem(12)} ${irem(12)};
      }
    }

    &:focus {
      outline: 0 !important;
    }

    .flickity-slider {
      height: 100%;
      ${props => props.theme.breakpoints.up('md')} {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .flickity-page-dots {
    position: absolute;
    bottom: ${irem(-50)};
    left: 50%;
    transform: translateX(-50%);
    padding: 0;
    list-style: none;
    text-align: center;
    line-height: 1;
    margin-bottom: 0;
      
    ${props => props.theme.breakpoints.up('md')} {
      left: ${irem(782)};
      bottom: ${irem(36)};
      transform: none;
    }

    li {
      margin: 0;

      &::before {
        display: none;
      }
    }

    .dot {
      display: inline-block;
      width: ${props => props.theme.typography.pxToRem(9)};
      height: ${props => props.theme.typography.pxToRem(9)};
      margin: 0 ${props => props.theme.typography.pxToRem(5)};
      background: #d9d9d9;
      border-radius: 50%;
      cursor: pointer;

      &.is-selected {
          background: transparent;
          border: 2px solid ${props => props.theme.custom.colors.darkRed};
      }
    }
  }
`